import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'suvo-bi-invite-entry',
  templateUrl: './invite-entry.component.html',
  styleUrls: ['./invite-entry.component.scss'],
})
export class InviteEntryComponent {
  @Input() name;
  @Input() isFocused: boolean;
  @Output() actioned: EventEmitter<boolean> = new EventEmitter<boolean>();

  action(accepted: boolean) {
    this.actioned.emit(accepted);
  }
}
